import React, {} from 'react';

//widget contexts
import WebEmbedProvider from '@/context/WebEmbed';

//components
import WebEmbedWidget from  '@/components/elements/widgets/webEmbed/WebEmbedWidget';

//styling
import '../../../css/widgetPanel/widgetPanel.scss';



const WidgetPanel = ({isPageView, isDCTEnabled}:{isPageView: boolean, isDCTEnabled: boolean}) => {
    return (
        <section className="widget-panel">
            <WebEmbedProvider isPageView={isPageView} isDCTEnabled={isDCTEnabled}>
                <WebEmbedWidget />
            </WebEmbedProvider>
        </section>
    )
}
export default WidgetPanel